import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-permissions-debug',
  templateUrl: './permissions-debug.component.html',
  styleUrls: ['./permissions-debug.component.scss']
})
export class PermissionsDebugComponent implements OnInit {

  employeeSearchFilter: string = "";
  filteredEmployeePermissiosn: string[] = [];
  fgEmployeePermissions: FormGroup = new FormGroup({ permission : new FormControl() });

  dealTeamSearchFilter: string = "";
  filteredDealTeamPermissions: string[] = [];
  fgDTPermissions: FormGroup = new FormGroup({ permission : new FormControl() });

  constructor(
    private dataService: DataService,
    private toastrService: ToastrService
  ) {

   }

  ngOnInit(): void {
    // this.filteredEmployeePermissiosn = this.dataService.currentEmployeePermissions;
    // this.filteredDealTeamPermissions = this.dataService.dealTeamPermissions;
    this.filterEmployeePermissions();
    this.filterDealTeamPermissions();
  }

  filterEmployeePermissions() {
    if (!!this.employeeSearchFilter)
      this.filteredEmployeePermissiosn = this.dataService.currentEmployeePermissions.filter(x => x.toUpperCase().includes(this.employeeSearchFilter.trim().toUpperCase()));
    else 
      this.filteredEmployeePermissiosn = this.dataService.currentEmployeePermissions;
  }

  submitEmployee() {
    if (this.fgEmployeePermissions.invalid) {
      this.toastrService.error("Form not valid")
      return;
    }

    var p = this.fgEmployeePermissions.value.permission.trim().toUpperCase();
    this.fgEmployeePermissions.reset();

    let newPermissions = this.dataService.currentEmployeePermissions.concat([p]);
    this.dataService.setEmployeeRolePermissions(newPermissions);
    this.ngOnInit();
  }

  removeEmployeePermission(p:string) {
    let newPermissions = this.dataService.currentEmployeePermissions.filter(x => x != p);
    this.dataService.setEmployeeRolePermissions(newPermissions);
    this.ngOnInit();
  }


  filterDealTeamPermissions() {
    if (!!this.dealTeamSearchFilter)
      this.filteredDealTeamPermissions = this.dataService.dealTeamPermissions.filter(x => x.toUpperCase().includes(this.dealTeamSearchFilter.trim().toUpperCase()));
    else 
      this.filteredDealTeamPermissions = this.dataService.dealTeamPermissions;
  }

  submitDealTeam() {
    if (this.fgDTPermissions.invalid) {
      this.toastrService.error("Form not valid")
      return;
    }

    var p = this.fgDTPermissions.value.permission.trim().toUpperCase();
    this.fgDTPermissions.reset();

    var newPermissions = this.dataService.dealTeamPermissions.concat([p]);
    this.dataService.setDealTeamPermissions(newPermissions);
    this.ngOnInit();
  }

  removeDealTeamPermission(p:string) {
    let newPermissions = this.dataService.dealTeamPermissions.filter(x => x != p);
    this.dataService.setDealTeamPermissions(newPermissions);
    this.ngOnInit();
  }

}
